import { inject } from './inject';
import { TermsAndConditions as BaseTermsAndConditions } from './TermsAndConditions';

export const TermsAndConditions = inject(BaseTermsAndConditions);
